import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProcessSelector = _resolveComponent("ProcessSelector")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ProcessSelector, { routes: _ctx.routes }, null, 8, ["routes"]),
    _createVNode(_component_router_view)
  ]))
}